import React, {
  useRef,
  useEffect,
  useCallback,
  MutableRefObject,
  useContext,
} from 'react';

import { Text } from '@atoms';

import { MapContext } from '@contexts/map-context';

import classes from './map-cursor-with-text.module.scss';

type Props = {
  boundingElement: MutableRefObject<null | HTMLDivElement>;
};

export const MIN_ZOOM_LEVEL_FOR_CURSOR_WITH_TEXT = 18;

export const MapCursorWithText = ({ boundingElement }: Props) => {
  const { zoom } = useContext(MapContext);
  const textWrapper = useRef<HTMLParagraphElement>(null);

  const onMouseMove = useCallback((e: MouseEvent) => {
    const { clientX, clientY } = e;

    if (boundingElement.current && textWrapper.current) {
      const { left, top } = boundingElement.current.getBoundingClientRect();

      const posX = clientX - left - 110;
      const posY = clientY - top - 15;

      textWrapper.current.style.left = `${posX}px`;
      textWrapper.current.style.top = `${posY}px`;
    }
  }, []);

  useEffect(() => {
    window.addEventListener('mousemove', onMouseMove);
    return () => window.removeEventListener('mousemove', onMouseMove);
  }, []);

  if (zoom < MIN_ZOOM_LEVEL_FOR_CURSOR_WITH_TEXT) {
    return null;
  }

  return (
    <Text
      className={classes.wrapper}
      innerRef={textWrapper}
      type="small"
      message={{ id: 'atlas.map_cursor.text' }}
    />
  );
};
